(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  const productSection = document.querySelector('.main-product');
  if (!productSection) return;

  const sectionId = productSection.querySelector('[data-section-id]')?.dataset.sectionId;
  if (!sectionId) return;

  const variantSelect = document.querySelector(`#ProductSelect-${sectionId}`);
  const addToCartButton = productSection.querySelector('#AddToCart');
  const availabilityValueEl = productSection.querySelector(`#ProductAvailabilityValue-${sectionId}`);
  const featuredImageEl = productSection.querySelector('.product-featured-image');
  const featuredImage = productSection.querySelector('.product-featured-image__img');
  const thumbnails = productSection.querySelectorAll('.images-row .image-card');
  const recommendedAddons = productSection.querySelector('[data-recommended-addons]');
  const recommendedAddonsContent = recommendedAddons ? recommendedAddons.querySelector('[data-recommended-addons-content]') : null;
  const currencyCode = recommendedAddons?.dataset.currencyCode || 'USD';
  const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: currencyCode,
  });
  const cartAddUrl = recommendedAddons?.dataset.cartAddUrl || '/cart/add.js';
  const cartStateUrl = recommendedAddons?.dataset.cartStateUrl || '/cart.js';

  // Keep the primary image responsive when a thumbnail or variant changes.
  function updateFeaturedImage(imageUrl, imageSrcset) {
    if (!featuredImageEl || !featuredImage) return;

    featuredImage.src = imageUrl;
    if (imageSrcset) featuredImage.srcset = imageSrcset;
    featuredImageEl.dataset.featuredImage = imageUrl;
  }

  function getSelectedAccessoryCheckboxes() {
    if (!recommendedAddons) return [];

    return Array.from(recommendedAddons.querySelectorAll('[data-accessory-checkbox]:checked:not(:disabled)'));
  }

  function getAccessoryItems() {
    return getSelectedAccessoryCheckboxes()
      .map((input) => ({
        id: Number(input.value),
        quantity: 1,
      }))
      .filter((item) => Number.isFinite(item.id) && item.id > 0);
  }

  function updateAccessoriesSummary() {
    if (!recommendedAddons) return;

    const checkedInputs = getSelectedAccessoryCheckboxes();
    const totalValueEl = recommendedAddons.querySelector('[data-accessories-total]');
    const addAllButton = recommendedAddons.querySelector('[data-add-all-accessories]');
    const total = checkedInputs.reduce((sum, input) => {
      const card = input.closest('[data-accessory-card]');
      const price = Number(card?.dataset.accessoryPrice || 0);
      return sum + price;
    }, 0);

    if (totalValueEl) {
      totalValueEl.textContent = moneyFormatter.format(total / 100);
    }

    if (addAllButton) {
      const hasItems = checkedInputs.length > 0;
      addAllButton.disabled = !hasItems;
      addAllButton.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
    }
  }

  function setAccessoriesStatus(message, isError) {
    const accessoriesStatus = recommendedAddons ? recommendedAddons.querySelector('[data-accessories-status]') : null;
    if (!accessoriesStatus) return;

    accessoriesStatus.textContent = message || '';
    accessoriesStatus.hidden = !message;
    accessoriesStatus.classList.toggle('is-error', Boolean(message && isError));
    accessoriesStatus.classList.toggle('is-success', Boolean(message && !isError));
  }

  function renderAccessories(variantId) {
    if (!recommendedAddons || !recommendedAddonsContent) return;

    const template = variantId
      ? productSection.querySelector(`template[data-variant-accessories="${variantId}"]`)
      : null;
    const markup = template ? template.innerHTML.trim() : '';

    recommendedAddonsContent.innerHTML = markup;
    recommendedAddons.hidden = !markup;
    setAccessoriesStatus('', false);

    if (!markup) return;

    updateAccessoriesSummary();
  }

  async function addItemsToCart(items) {
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items }),
    });

    const payload = await response.json();

    if (!response.ok || payload.status) {
      throw new Error(payload.description || payload.message || 'Unable to add items to the cart.');
    }

    return payload;
  }
  async function refreshCartSummary() {
    const response = await fetch(cartStateUrl, {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    const cart = await response.json();
    const shoppingCartLink = document.querySelector('.shopping-cart a');
    const countEl = shoppingCartLink?.querySelector('span:first-child');
    const totalEl = shoppingCartLink?.querySelector('span:last-child');

    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = moneyFormatter.format(cart.total_price / 100);

    if (shoppingCartLink) {
      shoppingCartLink.setAttribute(
        'aria-label',
        cart.item_count
          ? `Shopping Cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in cart`
          : 'Shopping Cart is empty'
      );
    }
  }

  function updatePurchaseAvailability(selectedOption) {
    if (!selectedOption) return;

    const isUnavailable = selectedOption.dataset.unavailable === 'true';
    const isDiscontinued = selectedOption.dataset.discontinued === 'true';

    if (availabilityValueEl) {
      const inStockLabel = variantSelect.dataset.inStockLabel;
      const soldOutLabel = variantSelect.dataset.soldOutLabel;
      const discontinuedLabel = variantSelect.dataset.discontinuedLabel;

      availabilityValueEl.textContent = isDiscontinued
        ? discontinuedLabel
        : isUnavailable
          ? soldOutLabel
          : inStockLabel;
    }

    if (addToCartButton) {
      addToCartButton.disabled = isUnavailable;
      addToCartButton.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
      addToCartButton.classList.toggle('add-to-cart-btn--disabled', isUnavailable);
    }
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function(e) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      updatePurchaseAvailability(selectedOption);
      renderAccessories(selectedOption.value);

      if (!featuredImageEl || !thumbnails || thumbnails.length === 0) return;

      const variantImageUrl = selectedOption.dataset.img;
      const variantImageId = selectedOption.dataset.imageId;

      // If variant has no image, keep the current featured image
      if (!variantImageUrl) return;

      const variantThumbnail = variantImageId
        ? Array.from(thumbnails).find((thumb) => thumb.dataset.imageId === variantImageId)
        : null;

      updateFeaturedImage(
        variantThumbnail?.dataset.image || variantImageUrl,
        variantThumbnail?.dataset.imageSrcset
      );

      // Find and highlight the matching thumbnail
      thumbnails.forEach(function(thumb) {
        thumb.classList.remove('current');
        if (variantThumbnail ? thumb === variantThumbnail : thumb.dataset.image === variantImageUrl) {
          thumb.classList.add('current');
        }
      });
    });

    updatePurchaseAvailability(variantSelect.options[variantSelect.selectedIndex]);
    renderAccessories(variantSelect.value);
  } else {
    updateAccessoriesSummary();
  }

  if (recommendedAddons) {
    recommendedAddons.addEventListener('change', function(e) {
      if (!e.target.matches('[data-accessory-checkbox]')) return;
      setAccessoriesStatus('', false);
      updateAccessoriesSummary();
    });

    recommendedAddons.addEventListener('click', async function(e) {
      const addAllButton = e.target.closest('[data-add-all-accessories]');
      if (!addAllButton) return;

      const items = getAccessoryItems();
      if (!items.length) return;

      e.preventDefault();
      if (addAllButton.dataset.loading === 'true') return;

      addAllButton.dataset.loading = 'true';
      addAllButton.disabled = true;
      setAccessoriesStatus('', false);

      try {
        await addItemsToCart(items);
        await refreshCartSummary();
        setAccessoriesStatus('Accessories added to cart', false);
      } catch (error) {
        setAccessoriesStatus(error.message, true);
      } finally {
        addAllButton.dataset.loading = 'false';
        updateAccessoriesSummary();
      }
    });
  }

  if (!featuredImageEl || !thumbnails || thumbnails.length === 0) return;

  // Handle thumbnail clicks - update featured image
  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      const imageUrl = this.dataset.image;

      updateFeaturedImage(imageUrl, this.dataset.imageSrcset);

      // Update active thumbnail
      thumbnails.forEach(function(t) {
        t.classList.remove('current');
      });
      this.classList.add('current');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
